import React, { useEffect, useState } from "react";
import style from "./reportShow.module.scss";
import Searchbar from "../productSearchbar/productSearchbar"
import Pagination from "../pagination/pagination"
import toPersianNumber from '../../helpers/actions/toPersianNumber'
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import Button from "../Button/button"
import ReportCard from "../reportShow/reportCard/reportCard"
import Skeleton from '../variantList/skeleton'
import { GetShowReportList, GenerateReportExcel } from "../../actions/APIcalls"
import { serverAddress } from "../../helpers/axiosFiles/axios";
import { withRouter, Link } from "react-router-dom";
import GradientToast from "../gradientToast/Toast"

const ReportShow = (props) => {

    const [hasSkeleton, setHasSkeleton] = useState(true)
    const [search, setSearch] = useState('');
    const [pageData, setPageData] = useState({ pageCount: 1, currentPage: 1, countInPage: 10, resultCount: 0 })
    const [sort, setSort] = useState({ key: "_id", by: 1 })
    const [list, setList] = useState([])
    //lifecyles*************************************************
    useEffect(() => {
        if (search !== "" || sort.key !== "_id") {
            getList()
        }
    }, [search, sort])
    useEffect(() => {
        window.addEventListener('popstate', () => {
            setSearch("")
        })
        return () => window.removeEventListener('popstate', () => {
        })
    }, [])
    useEffect(async () => {
        if (typeof props.location !== "undefined" && typeof props.location.search !== "undefined" && props.location.search !== "") {
            let url = new URLSearchParams(window.location.search);
            await setSearch(url.get("search"));
        }
        getList()
    }, [])
    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end
    //Get Data from server *************************************
    const getList = async () => {
        setHasSkeleton(true)
        let params = {
            id: typeof props.location.state.report !== "undefined" && props.location.state.report._id,
            page: pageData.currentPage,
            pageNumber: pageData.countInPage,
            sort: sort.key,
            by: sort.by,
            search: search
        }

        let res = await GetShowReportList(params)
        if (typeof res !== "undefined") {
            setList(res.data.report)
            let page = pageData
            page.pageCount = res.data.pageCount;
            page.resultCount = res.data.count
            setPageData({ ...page })
        }
        setHasSkeleton(false)
    }
    //handlers**************************************************
    const searchHandler = (tag, val) => {
        if (tag === "clear") {
            setSearch("")
        } else {
            setSearch(val);
            if (val != "") {
                props.history.push(
                    './' + `${props.location.state.report._id}` + "?search=" + val,
                    { search: val, id: props.location.state.report._id, report: { ...props.location.state.report } }
                );
            }
        }
    }
    const sortKeyHandler = (key) => {
        let SortData = sort
        SortData.key = key;
        SortData.by = -SortData.by
        setSort({ ...SortData })
        setList([])
    }
    const pageSetter = (number) => {
        let data = pageData
        data.currentPage = number
        setPageData({ ...data })
        getList()
    }

    const createExcel = async () => {
        let params = {
            id: typeof props.location.state.report !== "undefined" && props.location.state.report._id,
            sort: sort.key,
            by: sort.by,
        }
        let res = await GenerateReportExcel(params)
        if (res && res.data) {
            window.location.href = serverAddress + "getFiles/uploads/" + res.data.fileName
        }
    }


    if (hasSkeleton) {
        return <Skeleton />
    } else return (
        <div className={style.wrapper}>
            {
                props.user.expiredAccount &&
                <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <>
                            <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                            <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                            <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                        </>
                    </GradientToast>
                </div>
            }
            <div className={style.returnRow}>

                <div className={style.backButton} onClick={() => {
                    props.history.push("../reportlist")
                }}>
                    بازگشت
                    <span>c</span>
                </div>
            </div>
            <div className={style.headerWrapper}>
                <h3>گزارش {typeof props.location.state.report !== "undefined" && toPersianNumber(props.location.state.report.reportName)}</h3>
                <div className={style.buttonWrapper}>
                    <Button
                        disabled={false}
                        tag="cancelUpdate"
                        type="solid"
                        label="دانلود فایل اکسل گزارش"
                        onclick={() => createExcel()} />
                </div>
            </div>
            {list.length > 0 ?
                <React.Fragment>
                    <div className={style.searchbarWrapper}>
                        <Searchbar
                            placeholder={"عنوان یا کد کالا یا کد تنوع"}
                            value={search}
                            searchValue={(value) => searchHandler("add", value)}
                            clear={() => searchHandler("clear")}
                        />
                    </div>

                    < div className={style.cardComponents}>
                        <div className={style.pagination}>
                            <div className={style.Dropdown}>
                                <Pagination currentPage={pageData.currentPage} pageCount={pageData.pageCount}
                                    setPage={pageSetter} />
                                <TinyDropdown placeholder={10} dropdownList={["10", "25", "50", "75", "100"]}
                                    selected={selected => {
                                        let page = pageData;
                                        page.countInPage = selected;
                                        setPageData({ ...page })
                                        getList()
                                    }} />
                                <div className={style.label}>تعداد نمایش در صفحه</div>
                                <div className={style.verticalLine}></div>
                                <div
                                    className={style.variantCount}>{toPersianNumber(pageData.resultCount) + " نتیجه"}</div>
                            </div>
                        </div>

                        {list.length > 0 &&
                            <div className={style.newListWrapper}>
                                {list.length > 0 && <div className={style.hiddenListShadow}></div>}
                                <div className={style.listWrapper} style={list.length < 1 ? { overflowX: 'hidden' } : null}>

                                    {list.length > 0 && <>
                                        <div
                                            style={offset > 580 && (sessionStorage.getItem("sideBarOpen") && sessionStorage.getItem("sideBarOpen") == 'false') ? { width: 'calc(100% - 140px)' } : (offset > 580 ? { width: 'calc(100% - 280px)' } : null)}
                                            className={offset > 580 ? style.listHeaderShadowFixed : style.listHeaderShadow}>
                                            <div className={style.listHeader}>
                                                <div className={style.listHeaderFlexItem303}>مشخصات کالا</div>
                                                <div className={style.listHeaderItems}>وضعیت فروش</div>
                                                <div className={style.listHeaderItems}><p>موجودی دیجی‌کالا<span className={style.sortIcon} onClick={() => sortKeyHandler('digikalaStock')}>p</span></p></div>
                                                <div className={style.listHeaderItems}><p>قیمت فروش<span className={style.sortIcon} onClick={() => sortKeyHandler('salesPrice')}>p</span></p><span>(ریال)</span></div>
                                                <div className={style.listHeaderFlexItem32noMargin}></div>
                                            </div>
                                        </div>
                                        <div className={style.listHeader}></div>
                                    </>}

                                    <div className={style.mainListFrame}>
                                        {list.length > 0 &&
                                            list.map((item, index) => {
                                                return <div className={style.list} key={index}>
                                                    <ReportCard
                                                        data={item}
                                                        key={index}
                                                        show={typeof props.location.state.report !== "undefined" && { ...props.location.state.report.show }}
                                                    />
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        <div className={style.paginationTwo}>
                            <Pagination currentPage={pageData.currentPage} pageCount={pageData.pageCount}
                                setPage={pageSetter} />
                        </div>
                    </div>
                </React.Fragment>
                :
                <div className={style.empty}>
                    <React.Fragment>
                        <div className={style.noResultimage}></div>
                        <p className={style.boldText}>کاربر عزیز،
                            گزارش
                            {" "}{typeof props.location.state.report !== "undefined" && props.location.state.report.reportName}{" "}
                            هیچ نتیجه‌ای نداشت.</p>
                        <div className={style.buttonPack}>
                            <Button type="solid"
                                label={"ویرایش گزارش"}
                                onclick={() => props.history.push({
                                    pathname: "/report/create/",
                                    state: {
                                        id: typeof props.location.state.report !== "undefined" && props.location.state.report._id,
                                        report: typeof props.location.state.report !== "undefined" && { ...props.location.state.report }
                                    }
                                })}
                            />
                            <Button type="outline"
                                label={"ساخت گزارش جدید"}
                                onclick={() => props.history.push("/report/create")}
                            />
                        </div>
                    </React.Fragment>
                </div>


            }

        </div>
    )


}

export default withRouter(ReportShow);
